import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0004',
    ecrans: ['00-2'],
    params: ['id',
            '?prucleint',
            '?prbcleint',
            '?vaesysnatctb',
            '?pecann',
            '?indcleint']
});
